import { Outlet } from 'react-router';
import Header from '@/components/header/Header';
import { HeadTitle } from '@/components/HeadTitle';
import Footer from '@/components/footer/Footer';
import useScrollToTop from '@/hooks/useScrollToTop';
import SkipNav from '@/components/SkipNav';
import BodyTop from '@/components/BodyTop';
import FloatingBanner from '@/components/FloatingBanner';

const MainLayout = () => {
	// 페이지 이동 시 스크롤 최상단으로 이동
	useScrollToTop();

	return (
		<>
			<HeadTitle />
			<SkipNav />
			<BodyTop />
			<div id="wrapper" className="wrapper">
				<Header />
				<Outlet />
				<FloatingBanner />
			</div>
			<Footer />
		</>
	);
};

export default MainLayout;
